(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lmc-predictive-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lmc-search-suggest')) {
  customElements.define('lmc-search-suggest', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.input = this.querySelector('input[name="q"]');
      this.form = this.querySelector('form');
      this.panel = this.querySelector('.lmc-suggest-panel');
      this.list = this.querySelector('.lmc-suggest-list');
      this.message = this.querySelector('.lmc-suggest-message');
      this.status = this.querySelector('.lmc-suggest-status');
      this.all = this.querySelector('.lmc-suggest-all');
      if (!this.input || !this.form || !this.panel || !this.list || !this.message || !this.status || !this.all) return;
      this.events = new AbortController();
      this.sequence = 0;
      this.active = -1;
      this.items = [];
      this.input.setAttribute('role', 'combobox');
      this.input.setAttribute('aria-autocomplete', 'list');
      this.input.setAttribute('aria-controls', this.list.id);
      this.input.setAttribute('aria-expanded', 'false');
      const options = { signal: this.events.signal };
      this.input.addEventListener('input', () => this.schedule(), options);
      this.input.addEventListener('focus', () => this.schedule(), options);
      this.input.addEventListener('keydown', e => this.onKey(e), options);
      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) this.close(); }, options);
      this.addEventListener('keydown', e => {
        if (e.key === 'Escape' && e.target !== this.input) { e.preventDefault(); this.input.focus(); this.close(); }
      }, options);
      document.addEventListener('pointerdown', e => { if (!this.contains(e.target)) this.close(); }, options);
      this.list.addEventListener('pointerdown', e => {
        const item = e.target.closest('[data-lmc-option]');
        if (item && this.list.contains(item)) e.preventDefault();
      }, options);
      this.list.addEventListener('click', e => {
        const item = e.target.closest('[data-lmc-option]');
        if (!item || !this.list.contains(item)) return;
        const url = this.safeUrl(item.dataset.url);
        if (url) window.location.assign(url);
      }, options);
    }
    disconnectedCallback() {
      this.close();
      this.events?.abort();
      this.events = null;
    }
    safeUrl(value) {
      if (!value || typeof value !== 'string') return null;
      try {
        const url = new URL(value, window.location.origin);
        return url.origin === window.location.origin && /^https?:$/.test(url.protocol) ? url.href : null;
      } catch { return null; }
    }
    close() {
      clearTimeout(this.timer);
      this.sequence = (this.sequence || 0) + 1;
      this.request?.abort();
      if (!this.panel) return;
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.list.removeAttribute('aria-busy');
      this.status.textContent = '';
      this.active = -1;
    }
    schedule() {
      this.close();
      const query = this.input.value.trim();
      if (query.length < 2) return;
      const sequence = this.sequence;
      this.timer = setTimeout(() => this.load(query, sequence), 220);
    }
    async load(query, sequence) {
      if (sequence !== this.sequence || document.activeElement !== this.input) return;
      this.request = new AbortController();
      this.list.replaceChildren();
      this.items = [];
      this.message.textContent = this.dataset.loading;
      this.status.textContent = this.dataset.loading;
      this.list.setAttribute('aria-busy', 'true');
      const allUrl = new URL(this.form.action, window.location.origin);
      allUrl.searchParams.set('q', query);
      allUrl.searchParams.set('type', 'product');
      allUrl.searchParams.set('options[prefix]', 'last');
      this.all.href = allUrl.href;
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      try {
        const endpoint = this.safeUrl(this.dataset.url);
        if (!endpoint) throw new Error('Invalid search endpoint');
        const url = new URL(endpoint);
        if (!url.pathname.endsWith('.json')) url.pathname += '.json';
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        const response = await fetch(url.href, { signal: this.request.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (sequence !== this.sequence || document.activeElement !== this.input) return;
        const products = data?.resources?.results?.products;
        this.render(Array.isArray(products) ? products.slice(0, 6) : []);
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== this.sequence) return;
        this.message.textContent = this.dataset.error;
        this.status.textContent = this.dataset.error;
      } finally {
        if (sequence === this.sequence) this.list.removeAttribute('aria-busy');
      }
    }
    render(products) {
      this.list.replaceChildren();
      this.items = [];
      for (const product of products) {
        const url = this.safeUrl(product.url);
        if (!url || typeof product.title !== 'string') continue;
        const item = document.createElement('li');
        item.className = 'lmc-suggest-option';
        item.id = `${this.list.id}-${this.items.length}`;
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');
        item.dataset.lmcOption = '';
        item.dataset.url = url;
        if (typeof product.image === 'string' && product.image) {
          try {
            const source = new URL(product.image, window.location.origin);
            if (source.protocol === 'https:' && (source.origin === window.location.origin || source.hostname === 'cdn.shopify.com')) {
              source.searchParams.set('width', '88');
              const image = document.createElement('img');
              image.className = 'lmc-suggest-thumb';
              image.src = source.href;
              image.alt = '';
              image.width = 44;
              image.height = 44;
              image.loading = 'lazy';
              item.append(image);
            }
          } catch {}
        }
        const text = document.createElement('span');
        text.className = 'lmc-suggest-text';
        const title = document.createElement('span');
        title.textContent = product.title;
        text.append(title);
        if (typeof product.vendor === 'string' && product.vendor) {
          const vendor = document.createElement('span');
          vendor.className = 'lmc-suggest-vendor';
          vendor.textContent = product.vendor;
          text.append(vendor);
        }
        item.append(text);
        this.list.append(item);
        this.items.push(item);
      }
      this.active = -1;
      this.message.textContent = this.items.length ? '' : this.dataset.empty;
      this.status.textContent = this.items.length ? this.dataset.results : this.dataset.empty;
    }
    onKey(event) {
      if (event.isComposing) return;
      if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
      if (this.panel.hidden) return;
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && this.items.length) {
        event.preventDefault();
        const count = this.items.length;
        this.active = event.key === 'ArrowDown' ? (this.active + 1) % count : (this.active < 0 ? count - 1 : (this.active - 1 + count) % count);
        this.items.forEach((item, index) => item.setAttribute('aria-selected', String(index === this.active)));
        const item = this.items[this.active];
        this.input.setAttribute('aria-activedescendant', item.id);
        item.scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && this.active >= 0) {
        const url = this.safeUrl(this.items[this.active]?.dataset.url);
        if (url) { event.preventDefault(); window.location.assign(url); }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
